import { Component, computed, input, output } from '@angular/core';
import { RentalAgreementDriverDetailsModel } from '@app/features/operations/rental-agreements/rental-agreement-drivers/rental-agreement-drivers.model';
import { ReservationDriverDetailsModel } from '@app/features/operations/reservations/reservation-drivers/reservation-drivers.model';
import { AvatarModule } from 'primeng/avatar';

@Component({
  selector: 'app-driver-card',
  standalone: true,
  templateUrl: './driver-card.component.html',
  imports: [AvatarModule]
})
export class DriverCardComponent {
  driver = input<ReservationDriverDetailsModel | RentalAgreementDriverDetailsModel | null>();
  parentMode = input.required<'create' | 'update' | 'readonly'>();
  editClicked = output();

  label = computed(() => {
    const driver = this.driver();
    return driver ? `${driver.firstName?.charAt(0) ?? ''}${driver.lastName?.charAt(0) ?? ''}`.toUpperCase() : '?';
  });

  driverName = computed(() => {
    const driver = this.driver();
    return driver ? `${driver.firstName}, ${driver.lastName}`.toUpperCase() : 'Unknown Driver';
  });

  dialogLabel = computed(() => {
    const driver = this.driver();
    if (!driver) return 'Add';
    return this.parentMode() === 'readonly' ? 'Info' : 'Edit';
  });
}
